exports = module.exports = require("../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-list {\n  text-align: center;\n  color: #6e6e6e;\n  font-size: 18px;\n  padding: 70px 0;\n}\n.page-list li {\n  display: inline-block;\n  height: 31px;\n  width: 31px;\n  line-height: 30px;\n  margin: 0 7px;\n  transition: color 0.3s;\n  cursor: pointer;\n  background: transparent;\n  border: 0.5px solid rgba(52,52,52,0.3);\n}\n.page-list .active {\n  color: #fff;\n  background-color: #1c61a0;\n}\n.page-list li:hover {\n  color: #fff;\n  background-color: #1c61a0;\n}\n.page-list .active:hover {\n  color: #fff;\n}\n.page-list .icon-dot {\n  cursor: default;\n}\n.page-list .icon-dot:hover {\n  color: #fff;\n  background: #1c61a0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/app/share/pager/pager.component.styl
// module id = ../../../../../src/app/share/pager/pager.component.styl
// module chunks = main